import { Image, Text, View } from "@react-pdf/renderer";

import { formatResourceUrl } from "utils/common";

type SignatureSlotProps = {
  signedAtDate?: string;
  signatureImgUrl?: string;
  signatureSize?: { width: number; height: number };
  signatureLabel?: string;
  providerFullName?: string;
  licenseNumber?: string;
  signaturesCount?: number;
};

export default function SignatureSlot({
  signedAtDate,
  signatureImgUrl,
  signatureLabel,
  providerFullName,
  licenseNumber,
  signaturesCount = 1
}: SignatureSlotProps) {
  const multiline = signaturesCount > 1;

  return (
    <View
      style={{
        width: "500px",
        height: "80px",
        paddingLeft: "110px"
      }}
    >
      {Boolean(signedAtDate) && Boolean(signatureImgUrl) && (
        <View
          style={{
            width: "240px",
            height: "80px",
            display: "flex",
            justifyContent: "flex-end"
          }}
        >
          <Image
            style={{
              objectFit: "scale-down",
              paddingLeft: "15px",
              paddingRight: "5px",
              paddingBottom: "15px",
              width: "100%",
              height: "auto"
            }}
            src={formatResourceUrl(signatureImgUrl)}
          />
        </View>
      )}
      <Text
        style={{
          fontFamily: "LatoRegular",
          fontSize: "12px",
          position: "absolute",
          bottom: 8,
          fontWeight: "bold"
        }}
      >
        {signatureLabel}
      </Text>
      <Text
        style={{
          fontFamily: "LatoRegular",
          fontSize: "12px",
          position: "absolute",
          bottom: -12,
          width: "500px"
        }}
      >
        {providerFullName}{" "}
        {!multiline && licenseNumber ? `(License# ${licenseNumber})` : ""}
      </Text>
      {multiline && Boolean(licenseNumber) && (
        <Text
          style={{
            fontFamily: "LatoRegular",
            fontSize: "12px",
            position: "absolute",
            bottom: -24,
            width: "400px"
          }}
        >
          (License# {licenseNumber})
        </Text>
      )}
    </View>
  );
}
